/* eslint-disable react/destructuring-assignment */
import { MtProject } from "server/models"
import { LangType, UserData } from "client/store"
import { ReportDateFormatted } from "client/components/pdfmake/template/functions"
import * as Const from "client/components/pdfmake/template/const"

export const Header = (
    currentPage: number,
    project: MtProject,
) => {
    if (currentPage === 1) { // title page
        return []
    }

    return [{
        margin: [40, 30, 40, 0],
        columns: [
            {
                width: "*",
                text: project.documentId,
                fontSize: 11,
            },
            {
                image: "accountLogo",
                fit: [200, 50],
                alignment: "right",
                margin: [0, -10, 0, 0],
            },
        ],
    }]
}


export const Footer = (
    currentPage: number,
    pageCount: number,
    project: MtProject,
    userData: UserData,
    lang: LangType,
) => {
    if (currentPage === 1) { // title page
        const showDocumentId = project.documentId.trim().length > 0

        return [
            {
                style: Const.TITLE_DESCRIPTION,
                margin: [60, -120, 0, 0],
                columnGap: 30,
                columns: [
                    {
                        width: "15%",
                        stack: [
                            `${lang.project}:`,
                            `${lang.projectId}:`,
                            showDocumentId ? `${lang.documentId}:` : null,
                            `${lang.author}:`,
                            `${lang.revision}:`,
                        ],
                    },
                    [
                        project.name,
                        project.publicId,
                        showDocumentId ? project.documentId : null,
                        userData.userName,
                        ReportDateFormatted(),
                    ],
                ],
            },
            {
                fontSize: 8,
                margin: [56, showDocumentId ? 48 : 66, 56, 0],
                text: lang.pageOf.replace("{0}", currentPage.toString()).replace("{1}", pageCount.toString()),
                alignment: "right",
            },
        ]
    }

    return [
        {
            fontSize: 8,
            margin: [56, 16, 56, 0],
            columns: [
                {
                    width: "50%",
                    text: lang.reportCopyright,
                },
                {
                    width: "*",
                    text: lang.pageOf.replace("{0}", currentPage.toString()).replace("{1}", pageCount.toString()),
                    alignment: "right",
                },
            ],
        },
    ]
}
